import { createContext, useContext } from "react";
import { useLocalStorage } from "../hook/useStorage";

const AppContext = createContext(null);

const AppProvider = ({ children }) => {
  const [target, setTarget, removeTarget] = useLocalStorage("target", null);
  const [dealerships, setDealerships, removeDealerships] = useLocalStorage(
    "dealership",
    null
  );
  const [fetchData, setFetchData, removeFetchData] = useLocalStorage(
    "fetchData",
    null
  );
  const [artifact, setArtifact, removeArtifact] = useLocalStorage(
    "artifact",
    null
  );

  const [dealershipId, setDealershipId, removeDealershipId] = useLocalStorage(
    "dealershipId",
    null
  );

  const [dealershipCode, setDealershipCode, removeDealershipCode] =
    useLocalStorage("dealershipCode", null);
  const [omniLoginDate, setOmniLoginDate, removeOmniLoginDate] =
    useLocalStorage("omniLoginDate", null);

  const removeAll = () => {
    removeTarget();
    removeFetchData();
    removeDealerships();
    removeDealershipCode();
    removeDealershipId();
    removeOmniLoginDate();
  };

  return (
    <AppContext.Provider
      value={{
        target,
        removeAll,
        setTarget,
        dealerships,
        setDealerships,
        removeDealerships,
        fetchData,
        setFetchData,
        removeFetchData,
        artifact,
        setArtifact,
        removeArtifact,
        dealershipCode,
        setDealershipCode,
        dealershipId,
        setDealershipId,
        omniLoginDate,
        setOmniLoginDate,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

const useAppContext = () => {
  return useContext(AppContext);
};

export { AppProvider, useAppContext };
